// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynview-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.dynview-modal {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  width: 95%;
  max-width: 1400px;
  height: calc(88vh / var(--app-zoom, 1));
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header */
.dynview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.dynview-header h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.dynview-header-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.dynview-close {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  padding: 4px;
  display: flex;
  align-items: center;
}

.dynview-close:hover { color: #333; }

/* Tabs — 자원 분석과 같은 리본(2026-10-03 요청). 빈 자리도 같은 리본이되 비어 보이게(굵은 점선은 거슬렸다) */
.dynview-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 16px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.dynview-tab {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #4b5563;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}
.dynview-tab:hover { border-color: #3b82f6; }
.dynview-tab.active { border-color: #3b82f6; background: rgba(59, 130, 246, 0.1); color: #1d4ed8; font-weight: 600; }

.dynview-tab-view {
  font-size: 10px;
  font-family: var(--font-mono);
  color: #9ca3af;
  font-weight: 400;
}
.dynview-tab.active .dynview-tab-view { color: #3b82f6; }

/* 즐겨찾기가 5개 미만일 때 남는 자리 — 빈 리본(가는 실선 · 흐린 글자 · 바탕 없음) */
.dynview-tab-empty-slot { background: transparent; border-color: #e5e7eb; color: #9ca3af; font-weight: 400; }
.dynview-tab-empty-slot:hover { color: #3b82f6; border-color: #93c5fd; }
[data-theme="dark"] .dynview-tabs { border-bottom-color: var(--color-border); }
[data-theme="dark"] .dynview-tab { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text-secondary); }
[data-theme="dark"] .dynview-tab.active { border-color: var(--color-accent-fg); background: rgba(59, 130, 246, 0.18); color: #93c5fd; }
[data-theme="dark"] .dynview-tab-empty-slot { background: transparent; border-color: var(--color-border); color: var(--color-text-muted); }
[data-theme="dark"] .dynview-tab-empty-slot:hover { color: var(--color-text); }
@media (prefers-reduced-motion: reduce) { .dynview-tab { transition: none; } }

/* Body */
.dynview-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 10px;
  overflow: hidden;
  min-height: 0;
}

.dynview-tab-desc {
  font-size: 12px;
  color: #666;
  padding: 6px 10px;
  background: #f8f9fa;
  border-left: 3px solid var(--color-accent, #3b82f6);
  border-radius: 4px;
}

/* Query section */
.dynview-query-section {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.dynview-query-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.dynview-query-label {
  font-size: 12px;
  font-weight: 600;
  color: #333;
}

.dynview-query-actions {
  display: flex;
  gap: 6px;
}

.dynview-query-textarea {
  width: 100%;
  min-height: 120px;
  max-height: 220px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-family: var(--font-mono);
  font-size: 12px;
  line-height: 1.5;
  color: #333;
  background: #fafbfc;
  resize: vertical;
  box-sizing: border-box;
}

.dynview-query-textarea:focus {
  outline: none;
  border-color: var(--color-accent, #3b82f6);
}

.dynview-query-textarea[readonly] {
  background: #f3f4f6;
  cursor: default;
}

/* Status bar */
.dynview-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding: 4px 2px;
  color: #555;
  flex-shrink: 0;
}

.dynview-status-left,
.dynview-status-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dynview-status-sep {
  color: #ccc;
}

.dynview-status-empty {
  color: #999;
}

.dynview-loading {
  color: var(--color-accent, #3b82f6);
  font-weight: 500;
}

.dynview-autorefresh {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.dynview-select-inline {
  padding: 2px 6px;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  font-size: 12px;
  background: white;
}

.dynview-refresh-btn {
  background: none;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  padding: 4px 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #555;
}

.dynview-refresh-btn:hover:not(:disabled) {
  background: #f3f4f6;
  color: #333;
}

.dynview-refresh-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dynview-spin {
  animation: dynview-spin 1s linear infinite;
}

@keyframes dynview-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Error */
.dynview-error {
  padding: 10px 12px;
  background: #fee2e2;
  border: 1px solid #fca5a5;
  border-radius: 4px;
  font-size: 12px;
  color: #991b1b;
  flex-shrink: 0;
}

/* Grid */
.dynview-grid-container {
  flex: 1 1;
  overflow: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  min-height: 0;
}

.dynview-grid {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  font-family: var(--font-ui);
}

.dynview-grid thead {
  background: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 1;
}

.dynview-grid th {
  padding: 6px 10px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #d0d5db;
  white-space: nowrap;
  background: #f8f9fa;
}

.dynview-grid td {
  padding: 5px 10px;
  border-bottom: 1px solid #eee;
  color: #374151;
  white-space: nowrap;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dynview-grid tbody tr:hover {
  background: #f9fafb;
}


.dynview-rownum {
  text-align: right !important;
  color: #888 !important;
  background: #f8f9fa;
  font-family: var(--font-mono);
  font-size: 11px;
  width: 50px;
}

.dynview-null {
  color: #999;
  font-style: italic;
}

.dynview-empty {
  padding: 30px;
  text-align: center;
  color: #999;
  font-size: 13px;
}

/* Buttons */
.dynview-btn-primary,
.dynview-btn-secondary {
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  gap: 4px;
}

.dynview-btn-primary {
  background: var(--color-accent, #3b82f6);
  color: white;
  border-color: var(--color-accent, #3b82f6);
}

.dynview-btn-primary:hover:not(:disabled) {
  background: var(--color-accent-hover, #2563eb);
}

.dynview-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dynview-btn-secondary {
  background: white;
  color: #555;
  border-color: #d1d5db;
}

.dynview-btn-secondary:hover {
  background: #f3f4f6;
  color: #333;
}

.dynview-select {
  padding: 4px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  min-width: 180px;
}

/* Footer */
.dynview-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  border-top: 1px solid #e0e0e0;
  background: #fafbfc;
  flex-shrink: 0;
}

.dynview-footer-note {
  font-size: 11px;
  color: #888;
}

/* ===================== Dark mode ===================== */
[data-theme="dark"] .dynview-modal {
  background: var(--color-bg-tertiary);
  color: var(--color-text);
}

[data-theme="dark"] .dynview-header {
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .dynview-header h2 {
  color: var(--color-text);
}

[data-theme="dark"] .dynview-close {
  color: var(--color-text-muted);
}

[data-theme="dark"] .dynview-close:hover {
  color: var(--color-text);
}

[data-theme="dark"] .dynview-tabs {
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .dynview-tab {
  color: var(--color-text-secondary);
}

[data-theme="dark"] .dynview-tab:hover {
  background: var(--color-hover);
  color: var(--color-text);
}

[data-theme="dark"] .dynview-tab.active {
  color: var(--color-accent-fg);
  background: var(--color-bg-tertiary);
}

[data-theme="dark"] .dynview-tab-view {
  color: var(--color-text-muted);
}

[data-theme="dark"] .dynview-tab-desc {
  background: var(--color-bg-secondary);
  color: var(--color-text-secondary);
  border-left-color: var(--color-accent-fg);
}

[data-theme="dark"] .dynview-query-label {
  color: var(--color-text);
}

[data-theme="dark"] .dynview-query-textarea {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}

[data-theme="dark"] .dynview-query-textarea[readonly] {
  background: var(--color-bg-secondary);
}

[data-theme="dark"] .dynview-status {
  color: var(--color-text-secondary);
}

[data-theme="dark"] .dynview-status-sep {
  color: var(--color-border);
}

[data-theme="dark"] .dynview-error {
  background: #3a1a1a;
  color: #ef5350;
  border-color: #c62828;
}

[data-theme="dark"] .dynview-grid-container {
  border-color: var(--color-border);
}

[data-theme="dark"] .dynview-grid thead {
  background: var(--color-bg-secondary);
}

[data-theme="dark"] .dynview-grid th {
  color: var(--color-text);
  background: var(--color-bg-secondary);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .dynview-grid td {
  color: var(--color-text);
  border-bottom-color: var(--color-border);
}

[data-theme="dark"] .dynview-grid tbody tr:hover {
  background: var(--color-hover);
}


[data-theme="dark"] .dynview-rownum {
  background: var(--color-bg-secondary) !important;
  color: var(--color-text-muted) !important;
}

[data-theme="dark"] .dynview-null,
[data-theme="dark"] .dynview-empty,
[data-theme="dark"] .dynview-status-empty {
  color: var(--color-text-muted);
}

[data-theme="dark"] .dynview-select,
[data-theme="dark"] .dynview-select-inline {
  background: var(--color-input-bg);
  border-color: var(--color-input-border);
  color: var(--color-text);
}

[data-theme="dark"] .dynview-btn-secondary {
  background: var(--color-btn-bg);
  color: var(--color-text);
  border-color: var(--color-btn-border);
}

/* color 를 빠뜨리면 밝은 모드의 \`color: #333\` 이 그대로 남아 어두운 배경에 검은 글자가 된다 */
[data-theme="dark"] .dynview-btn-secondary:hover {
  background: var(--color-hover);
  color: var(--color-text);
}

[data-theme="dark"] .dynview-refresh-btn {
  background: var(--color-btn-bg);
  color: var(--color-text-secondary);
  border-color: var(--color-btn-border);
}

[data-theme="dark"] .dynview-refresh-btn:hover:not(:disabled) {
  background: var(--color-hover);
  color: var(--color-text);
}

[data-theme="dark"] .dynview-footer {
  background: var(--color-bg-secondary);
  border-top-color: var(--color-border);
}

[data-theme="dark"] .dynview-footer-note {
  color: var(--color-text-muted);
}

/* ── 동적뷰 즐겨찾기 선택 패널 ─────────────────────────────────────
   최대 5개 탭으로 표시되는 뷰를 이 목록에서 고른다(체크박스, 설명 포함). */
.dynview-picker-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  color: #374151;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;
}
.dynview-picker-toggle:hover { border-color: #3b82f6; }
@media (prefers-reduced-motion: reduce) { .dynview-picker-toggle { transition: none; } }

.dynview-picker-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}
.dynview-picker-panel {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  width: 90%;
  max-width: 640px;
  /* 목록이 줄면 창이 같이 줄어 검색할 때마다 화면이 출렁였다(사용자 신고).
     높이를 못 박아 **결과 수와 무관하게 같은 크기**를 유지한다 — 남는 자리는 비워 둔다. */
  height: calc(78vh / var(--app-zoom, 1));
  max-height: calc(78vh / var(--app-zoom, 1));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: dynview-fade-swap 160ms ease-out;
}
@keyframes dynview-fade-swap {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}
@media (prefers-reduced-motion: reduce) { .dynview-picker-panel { animation: none; } }

.dynview-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  font-size: 13px;
  font-weight: 600;
  color: #333;
  flex-shrink: 0;
}
.dynview-picker-count { font-weight: 400; color: #6b7280; margin-left: 6px; }

.dynview-picker-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 6px;
}
.dynview-picker-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 10px;
  border: none;
  border-radius: 6px;
  background: none;
  text-align: left;
  cursor: pointer;
  transition: background-color 150ms ease;
}
.dynview-picker-row:hover { background: #f3f4f6; }
.dynview-picker-row.on { background: #eff6ff; }
.dynview-picker-row.disabled { cursor: not-allowed; opacity: 0.45; }
.dynview-picker-star { flex-shrink: 0; color: #d1d5db; }
.dynview-picker-star.on { color: #f59e0b; fill: #f59e0b; }
.dynview-picker-name { flex-shrink: 0; font-size: 12.5px; font-weight: 600; color: #374151; min-width: 160px; }
.dynview-picker-view {
  flex-shrink: 0;
  font-family: var(--font-mono);
  font-size: 10.5px;
  color: #6b7280;
  background: #f3f4f6;
  border-radius: 4px;
  padding: 1px 6px;
}
.dynview-picker-desc { font-size: 11.5px; color: #9ca3af; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
@media (prefers-reduced-motion: reduce) { .dynview-picker-row { transition: none; } }

.dynview-picker-footnote {
  padding: 8px 14px;
  border-top: 1px solid #f3f4f6;
  font-size: 11px;
  color: #9ca3af;
  flex-shrink: 0;
}

.dynview-tab-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 60px 20px;
  color: #9ca3af;
  font-size: 13px;
}

[data-theme="dark"] .dynview-picker-toggle { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text); }
[data-theme="dark"] .dynview-picker-panel { background: var(--color-bg-tertiary); color: var(--color-text); }
[data-theme="dark"] .dynview-picker-header { background: var(--color-bg-secondary); border-color: var(--color-border); color: var(--color-text); }
[data-theme="dark"] .dynview-picker-count { color: var(--color-text-muted); }
[data-theme="dark"] .dynview-picker-row:hover { background: var(--color-hover); }
[data-theme="dark"] .dynview-picker-row.on { background: rgba(59, 130, 246, 0.15); }
[data-theme="dark"] .dynview-picker-name { color: var(--color-text); }
[data-theme="dark"] .dynview-picker-view { background: var(--color-bg-secondary); color: var(--color-text-muted); }
[data-theme="dark"] .dynview-picker-desc { color: var(--color-text-muted); }
[data-theme="dark"] .dynview-picker-star { color: var(--color-border); }
[data-theme="dark"] .dynview-picker-star.on { color: #fbbf24; fill: #fbbf24; }
[data-theme="dark"] .dynview-picker-footnote { color: var(--color-text-muted); border-color: var(--color-border); }
[data-theme="dark"] .dynview-tab-empty { color: var(--color-text-muted); }

/* 카탈로그 검색창 (picker 헤더 바로 아래) */
.dynview-picker-search {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-bottom: 1px solid #f3f4f6;
  color: #9ca3af;
  flex-shrink: 0;
}
.dynview-picker-search input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 12.5px;
  color: #374151;
  background: transparent;
}
.dynview-picker-refresh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 4px;
  background: none;
  color: #9ca3af;
  cursor: pointer;
}
.dynview-picker-refresh:hover:not(:disabled) { background: #f3f4f6; color: #374151; }
.dynview-picker-refresh:disabled { cursor: not-allowed; opacity: 0.5; }

.dynview-picker-status {
  padding: 20px 12px;
  text-align: center;
  font-size: 12.5px;
  color: #9ca3af;
}
.dynview-picker-status.error { color: #b91c1c; }

/* GV\$ 와 짝이 있는 V\$ 숨기기 토글 — 검색창 바로 아래 */
.dynview-hide-v-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 11.5px;
  color: #6b7280;
  cursor: pointer;
  flex-shrink: 0;
}

/* 그리드 아래 상태바의 "다음 200건" — 커서 기반 추가 fetch */
.dynview-fetchmore-btn {
  margin-left: 8px;
  padding: 2px 10px;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  background: #fff;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.dynview-fetchmore-btn:hover:not(:disabled) { background: #eff6ff; border-color: #3b82f6; }
.dynview-fetchmore-btn:disabled { opacity: 0.6; cursor: not-allowed; }

[data-theme="dark"] .dynview-picker-search { border-color: var(--color-border); color: var(--color-text-muted); }
[data-theme="dark"] .dynview-picker-search input { color: var(--color-text); }
[data-theme="dark"] .dynview-picker-refresh { color: var(--color-text-muted); }
[data-theme="dark"] .dynview-picker-refresh:hover:not(:disabled) { background: var(--color-hover); color: var(--color-text); }
[data-theme="dark"] .dynview-hide-v-toggle { border-color: var(--color-border); color: var(--color-text-muted); }
[data-theme="dark"] .dynview-fetchmore-btn { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: #93c5fd; }
[data-theme="dark"] .dynview-fetchmore-btn:hover:not(:disabled) { background: var(--color-hover); border-color: var(--color-hover-border, #5a5a5a); }
[data-theme="dark"] .dynview-picker-status { color: var(--color-text-muted); }
[data-theme="dark"] .dynview-picker-status.error { color: #f87171; }

/* ── 그리드 조작 (2026-09-21) ───────────────────────────────────── */
/* 값 클릭 = 그 값으로 거르기, 머리글 클릭 = 정렬, 더블클릭 = 고정.
   누를 수 있다는 것이 보여야 아무도 찾지 못하는 기능이 되지 않는다. */
.dynview-th-sortable { cursor: pointer; -webkit-user-select: none; user-select: none; }
.dynview-th-sortable:hover { background: #eef2ff; }
.dynview-th-sorted-asc,
.dynview-th-sorted-desc { color: #1d4ed8; }
.dynview-sort-mark { font-style: normal; font-size: 9px; margin-left: 4px; }

.dynview-td-filterable { cursor: pointer; }
.dynview-td-filterable:hover { background: #eff6ff; outline: 1px solid #bfdbfe; outline-offset: -1px; }

/* 행번호 열은 늘 왼쪽 끝에(가로 스크롤에도). 고정한 열은 그 뒤에 제자리에서 선다(utils/gridPin).
   고정 칸은 배경이 있어야 한다 — 없으면 밑으로 지나가는 칸이 비친다 */
.dynview-grid .dynview-rownum { position: sticky; left: 0; z-index: 2; }
.dynview-grid thead .dynview-rownum { z-index: 4; }
.dynview-grid td.dynview-pin { position: sticky; z-index: 1; background: #fff; }
.dynview-grid th.dynview-pin { position: sticky; z-index: 3; }
.dynview-grid .dynview-pin-last { box-shadow: inset -2px 0 0 rgba(59, 130, 246, 0.5); }
.dynview-grid tbody tr:hover td.dynview-pin { background: #f9fafb; }
[data-theme="dark"] .dynview-grid td.dynview-pin { background: var(--color-bg-tertiary); }
[data-theme="dark"] .dynview-grid tbody tr:hover td.dynview-pin { background: var(--color-hover); }

/* ── 조건·인스턴스 리본 ─────────────────────────────────────────── */
.dynview-filter-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 6px;
  animation: dynview-fade-swap 160ms ease-out;
}

.dynview-filter-label { font-size: 11px; color: #6b7280; }

.dynview-filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 4px 2px 8px;
  border-radius: 999px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #1e40af;
  font-size: 11px;
  max-width: 280px;
}
.dynview-filter-chip b { font-weight: 600; }
.dynview-filter-chip code {
  font-family: var(--font-mono);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}
.dynview-filter-chip button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px; height: 15px;
  border: none;
  border-radius: 50%;
  background: rgba(0,0,0,0.06);
  color: #1e40af;
  cursor: pointer;
  padding: 0;
}
.dynview-filter-chip button:hover { background: rgba(0,0,0,0.14); }
.dynview-filter-chip button:disabled { opacity: 0.4; cursor: not-allowed; }

.dynview-inst-chip {
  padding: 2px 9px;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
  font-size: 11px;
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease;
}
.dynview-inst-chip:hover { border-color: #3b82f6; }
.dynview-inst-chip.active { background: #3b82f6; border-color: #3b82f6; color: #fff; }
.dynview-inst-chip:disabled { opacity: 0.4; cursor: not-allowed; }

.dynview-filter-note { font-size: 11px; color: #b45309; }

[data-theme="dark"] .dynview-th-sortable:hover { background: var(--color-hover); }
[data-theme="dark"] .dynview-td-filterable:hover { background: var(--color-hover); outline-color: var(--color-btn-border); }

[data-theme="dark"] .dynview-filter-chip { background: #1e3a8a; border-color: #1d4ed8; color: #dbeafe; }
[data-theme="dark"] .dynview-filter-chip button { background: rgba(255,255,255,0.12); color: #dbeafe; }
[data-theme="dark"] .dynview-inst-chip { background: var(--color-input-bg); border-color: var(--color-border); color: var(--color-text); }
[data-theme="dark"] .dynview-inst-chip.active { background: #2563eb; border-color: #2563eb; color: #fff; }
[data-theme="dark"] .dynview-filter-note { color: #fcd34d; }

@media (prefers-reduced-motion: reduce) {
  .dynview-filter-bar { animation: none; }
  .dynview-inst-chip { transition: none; }
}

/* 결과 검색 — 세션 분석과 같은 꼴(2026-10-03) */
.dynview-search { display: flex; align-items: center; gap: 6px; padding: 3px 8px; border: 1px solid #d1d5db; border-radius: 4px; background: #fff; color: #9ca3af; min-width: 200px; }
.dynview-search input { flex: 1 1; border: none; outline: none; font-size: 12px; background: transparent; color: #374151; min-width: 0; }
.dynview-search-clear { display: inline-flex; border: none; background: none; padding: 1px; border-radius: 3px; color: #9ca3af; cursor: pointer; transition: background-color 150ms ease, color 150ms ease; }
.dynview-search-clear:hover { background: #e5e7eb; color: #374151; }
.dynview-td-searching { box-shadow: inset 0 -2px 0 #3b82f6; }
[data-theme="dark"] .dynview-search { background: var(--color-input-bg); border-color: var(--color-input-border); color: var(--color-text-muted); }
[data-theme="dark"] .dynview-search input { color: var(--color-text); }
[data-theme="dark"] .dynview-search-clear:hover { background: var(--color-hover); color: var(--color-text); }
@media (prefers-reduced-motion: reduce) { .dynview-search-clear { transition: none; } }
`, "",{"version":3,"sources":["webpack://./src/components/monitoring/DynamicViewExplorerModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,iBAAiB;EACjB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA,uBAAuB,WAAW,EAAE;;AAEpC,0EAA0E;AAC1E;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kFAAkF;AACpF;AACA,qBAAqB,qBAAqB,EAAE;AAC5C,sBAAsB,qBAAqB,EAAE,mCAAmC,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAEpH;EACE,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;AACA,wCAAwC,cAAc,EAAE;;AAExD,uDAAuD;AACvD,0BAA0B,uBAAuB,EAAE,qBAAqB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC5G,gCAAgC,cAAc,EAAE,qBAAqB,EAAE;AACvE,oCAAoC,wCAAwC,EAAE;AAC9E,mCAAmC,+BAA+B,EAAE,qCAAqC,EAAE,kCAAkC,EAAE;AAC/I,0CAA0C,oCAAoC,EAAE,oCAAoC,EAAE,cAAc,EAAE;AACtI,8CAA8C,uBAAuB,EAAE,iCAAiC,EAAE,8BAA8B,EAAE;AAC1I,oDAAoD,wBAAwB,EAAE;AAC9E,0CAA0C,eAAe,gBAAgB,EAAE,EAAE;;AAE7E,SAAS;AACT;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,SAAO;EACP,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA,YAAY;AACZ;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,0DAA0D;AAC1D;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;;AAGA;EACE,gDAAgD;EAChD,yCAAyC;AAC3C;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;;EAEE,iCAAiC;EACjC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA,iEAAiE;AACjE;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;+CAC+C;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gEAAgE;AAClE;AACA,+BAA+B,qBAAqB,EAAE;AACtD,0CAA0C,yBAAyB,gBAAgB,EAAE,EAAE;;AAEvF;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,UAAU;EACV,gBAAgB;EAChB;0DACwD;EACxD,uCAAuC;EACvC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA,0CAA0C,wBAAwB,eAAe,EAAE,EAAE;;AAErF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA,wBAAwB,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAE5E;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;AACA,4BAA4B,mBAAmB,EAAE;AACjD,yBAAyB,mBAAmB,EAAE;AAC9C,+BAA+B,mBAAmB,EAAE,aAAa,EAAE;AACnE,uBAAuB,cAAc,EAAE,cAAc,EAAE;AACvD,0BAA0B,cAAc,EAAE,aAAa,EAAE;AACzD,uBAAuB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC9G;EACE,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,uBAAuB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC1H,0CAA0C,sBAAsB,gBAAgB,EAAE,EAAE;;AAEpF;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,6CAA6C,+BAA+B,EAAE,qCAAqC,EAAE,wBAAwB,EAAE;AAC/I,4CAA4C,oCAAoC,EAAE,wBAAwB,EAAE;AAC5G,6CAA6C,qCAAqC,EAAE,iCAAiC,EAAE,wBAAwB,EAAE;AACjJ,4CAA4C,8BAA8B,EAAE;AAC5E,gDAAgD,8BAA8B,EAAE;AAChF,6CAA6C,oCAAoC,EAAE;AACnF,2CAA2C,wBAAwB,EAAE;AACrE,2CAA2C,qCAAqC,EAAE,8BAA8B,EAAE;AAClH,2CAA2C,8BAA8B,EAAE;AAC3E,2CAA2C,0BAA0B,EAAE;AACvE,8CAA8C,cAAc,EAAE,aAAa,EAAE;AAC7E,+CAA+C,8BAA8B,EAAE,iCAAiC,EAAE;AAClH,yCAAyC,8BAA8B,EAAE;;AAEzE,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA,+CAA+C,mBAAmB,EAAE,cAAc,EAAE;AACpF,mCAAmC,mBAAmB,EAAE,YAAY,EAAE;;AAEtE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA,+BAA+B,cAAc,EAAE;;AAE/C,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,8CAA8C,mBAAmB,EAAE,qBAAqB,EAAE;AAC1F,kCAAkC,YAAY,EAAE,mBAAmB,EAAE;;AAErE,6CAA6C,iCAAiC,EAAE,8BAA8B,EAAE;AAChH,mDAAmD,wBAAwB,EAAE;AAC7E,8CAA8C,8BAA8B,EAAE;AAC9E,mEAAmE,8BAA8B,EAAE,wBAAwB,EAAE;AAC7H,6CAA6C,iCAAiC,EAAE,8BAA8B,EAAE;AAChH,6CAA6C,+BAA+B,EAAE,qCAAqC,EAAE,cAAc,EAAE;AACrI,kEAAkE,8BAA8B,EAAE,gDAAgD,EAAE;AACpJ,6CAA6C,8BAA8B,EAAE;AAC7E,mDAAmD,cAAc,EAAE;;AAEnE,iEAAiE;AACjE;2CAC2C;AAC3C,uBAAuB,eAAe,EAAE,yBAAiB,EAAjB,iBAAiB,EAAE;AAC3D,6BAA6B,mBAAmB,EAAE;AAClD;0BAC0B,cAAc,EAAE;AAC1C,qBAAqB,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAE3E,yBAAyB,eAAe,EAAE;AAC1C,+BAA+B,mBAAmB,EAAE,0BAA0B,EAAE,oBAAoB,EAAE;;AAEtG;2CAC2C;AAC3C,gCAAgC,gBAAgB,EAAE,OAAO,EAAE,UAAU,EAAE;AACvE,sCAAsC,UAAU,EAAE;AAClD,+BAA+B,gBAAgB,EAAE,UAAU,EAAE,gBAAgB,EAAE;AAC/E,+BAA+B,gBAAgB,EAAE,UAAU,EAAE;AAC7D,kCAAkC,kDAAkD,EAAE;AACtF,8CAA8C,mBAAmB,EAAE;AACnE,mDAAmD,oCAAoC,EAAE;AACzF,kEAAkE,8BAA8B,EAAE;;AAElG,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,wBAAwB,eAAe,EAAE,cAAc,EAAE;;AAEzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,yBAAyB,gBAAgB,EAAE;AAC3C;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,YAAY;EACzB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,UAAU;AACZ;AACA,oCAAoC,4BAA4B,EAAE;AAClE,uCAAuC,YAAY,EAAE,mBAAmB,EAAE;;AAE1E;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,0DAA0D;AAC5D;AACA,2BAA2B,qBAAqB,EAAE;AAClD,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;AACrF,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;;AAEjE,uBAAuB,eAAe,EAAE,cAAc,EAAE;;AAExD,iDAAiD,8BAA8B,EAAE;AACjF,mDAAmD,8BAA8B,EAAE,sCAAsC,EAAE;;AAE3H,2CAA2C,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACvG,kDAAkD,kCAAkC,EAAE,cAAc,EAAE;AACtG,yCAAyC,iCAAiC,EAAE,iCAAiC,EAAE,wBAAwB,EAAE;AACzI,gDAAgD,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;AACzG,2CAA2C,cAAc,EAAE;;AAE3D;EACE,sBAAsB,eAAe,EAAE;EACvC,qBAAqB,gBAAgB,EAAE;AACzC;;AAEA,oCAAoC;AACpC,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACrL,wBAAwB,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,eAAe,EAAE,uBAAuB,EAAE,cAAc,EAAE,YAAY,EAAE;AACtI,wBAAwB,oBAAoB,EAAE,YAAY,EAAE,gBAAgB,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE,yDAAyD,EAAE;AAC5M,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,wBAAwB,kCAAkC,EAAE;AAC5D,sCAAsC,iCAAiC,EAAE,uCAAuC,EAAE,8BAA8B,EAAE;AAClJ,4CAA4C,wBAAwB,EAAE;AACtE,kDAAkD,8BAA8B,EAAE,wBAAwB,EAAE;AAC5G,0CAA0C,wBAAwB,gBAAgB,EAAE,EAAE","sourcesContent":[".dynview-overlay {\r\n  position: fixed;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1001;\r\n}\r\n\r\n.dynview-modal {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\r\n  width: 95%;\r\n  max-width: 1400px;\r\n  height: calc(88vh / var(--app-zoom, 1));\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Header */\r\n.dynview-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 16px;\r\n  background: #f8f9fa;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dynview-header h2 {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.dynview-header-controls {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.dynview-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  color: #999;\r\n  padding: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.dynview-close:hover { color: #333; }\r\n\r\n/* Tabs — 자원 분석과 같은 리본(2026-10-03 요청). 빈 자리도 같은 리본이되 비어 보이게(굵은 점선은 거슬렸다) */\r\n.dynview-tabs {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  padding: 8px 16px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dynview-tab {\r\n  display: inline-flex;\r\n  align-items: baseline;\r\n  gap: 6px;\r\n  padding: 4px 12px;\r\n  border-radius: 999px;\r\n  border: 1px solid #d1d5db;\r\n  background: #fff;\r\n  color: #4b5563;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;\r\n}\r\n.dynview-tab:hover { border-color: #3b82f6; }\r\n.dynview-tab.active { border-color: #3b82f6; background: rgba(59, 130, 246, 0.1); color: #1d4ed8; font-weight: 600; }\r\n\r\n.dynview-tab-view {\r\n  font-size: 10px;\r\n  font-family: var(--font-mono);\r\n  color: #9ca3af;\r\n  font-weight: 400;\r\n}\r\n.dynview-tab.active .dynview-tab-view { color: #3b82f6; }\r\n\r\n/* 즐겨찾기가 5개 미만일 때 남는 자리 — 빈 리본(가는 실선 · 흐린 글자 · 바탕 없음) */\r\n.dynview-tab-empty-slot { background: transparent; border-color: #e5e7eb; color: #9ca3af; font-weight: 400; }\r\n.dynview-tab-empty-slot:hover { color: #3b82f6; border-color: #93c5fd; }\r\n[data-theme=\"dark\"] .dynview-tabs { border-bottom-color: var(--color-border); }\r\n[data-theme=\"dark\"] .dynview-tab { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text-secondary); }\r\n[data-theme=\"dark\"] .dynview-tab.active { border-color: var(--color-accent-fg); background: rgba(59, 130, 246, 0.18); color: #93c5fd; }\r\n[data-theme=\"dark\"] .dynview-tab-empty-slot { background: transparent; border-color: var(--color-border); color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .dynview-tab-empty-slot:hover { color: var(--color-text); }\r\n@media (prefers-reduced-motion: reduce) { .dynview-tab { transition: none; } }\r\n\r\n/* Body */\r\n.dynview-body {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 12px 16px;\r\n  gap: 10px;\r\n  overflow: hidden;\r\n  min-height: 0;\r\n}\r\n\r\n.dynview-tab-desc {\r\n  font-size: 12px;\r\n  color: #666;\r\n  padding: 6px 10px;\r\n  background: #f8f9fa;\r\n  border-left: 3px solid var(--color-accent, #3b82f6);\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Query section */\r\n.dynview-query-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dynview-query-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.dynview-query-label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.dynview-query-actions {\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n.dynview-query-textarea {\r\n  width: 100%;\r\n  min-height: 120px;\r\n  max-height: 220px;\r\n  padding: 8px 10px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  font-family: var(--font-mono);\r\n  font-size: 12px;\r\n  line-height: 1.5;\r\n  color: #333;\r\n  background: #fafbfc;\r\n  resize: vertical;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.dynview-query-textarea:focus {\r\n  outline: none;\r\n  border-color: var(--color-accent, #3b82f6);\r\n}\r\n\r\n.dynview-query-textarea[readonly] {\r\n  background: #f3f4f6;\r\n  cursor: default;\r\n}\r\n\r\n/* Status bar */\r\n.dynview-status {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 12px;\r\n  padding: 4px 2px;\r\n  color: #555;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dynview-status-left,\r\n.dynview-status-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.dynview-status-sep {\r\n  color: #ccc;\r\n}\r\n\r\n.dynview-status-empty {\r\n  color: #999;\r\n}\r\n\r\n.dynview-loading {\r\n  color: var(--color-accent, #3b82f6);\r\n  font-weight: 500;\r\n}\r\n\r\n.dynview-autorefresh {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.dynview-select-inline {\r\n  padding: 2px 6px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 3px;\r\n  font-size: 12px;\r\n  background: white;\r\n}\r\n\r\n.dynview-refresh-btn {\r\n  background: none;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  padding: 4px 6px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  color: #555;\r\n}\r\n\r\n.dynview-refresh-btn:hover:not(:disabled) {\r\n  background: #f3f4f6;\r\n  color: #333;\r\n}\r\n\r\n.dynview-refresh-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.dynview-spin {\r\n  animation: dynview-spin 1s linear infinite;\r\n}\r\n\r\n@keyframes dynview-spin {\r\n  from { transform: rotate(0deg); }\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n/* Error */\r\n.dynview-error {\r\n  padding: 10px 12px;\r\n  background: #fee2e2;\r\n  border: 1px solid #fca5a5;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  color: #991b1b;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Grid */\r\n.dynview-grid-container {\r\n  flex: 1;\r\n  overflow: auto;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 4px;\r\n  min-height: 0;\r\n}\r\n\r\n.dynview-grid {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 12px;\r\n  font-family: var(--font-ui);\r\n}\r\n\r\n.dynview-grid thead {\r\n  background: #f8f9fa;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.dynview-grid th {\r\n  padding: 6px 10px;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #333;\r\n  border-bottom: 2px solid #d0d5db;\r\n  white-space: nowrap;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.dynview-grid td {\r\n  padding: 5px 10px;\r\n  border-bottom: 1px solid #eee;\r\n  color: #374151;\r\n  white-space: nowrap;\r\n  max-width: 400px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.dynview-grid tbody tr:hover {\r\n  background: #f9fafb;\r\n}\r\n\r\n\r\n.dynview-rownum {\r\n  text-align: right !important;\r\n  color: #888 !important;\r\n  background: #f8f9fa;\r\n  font-family: var(--font-mono);\r\n  font-size: 11px;\r\n  width: 50px;\r\n}\r\n\r\n.dynview-null {\r\n  color: #999;\r\n  font-style: italic;\r\n}\r\n\r\n.dynview-empty {\r\n  padding: 30px;\r\n  text-align: center;\r\n  color: #999;\r\n  font-size: 13px;\r\n}\r\n\r\n/* Buttons */\r\n.dynview-btn-primary,\r\n.dynview-btn-secondary {\r\n  padding: 4px 10px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  border: 1px solid transparent;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.dynview-btn-primary {\r\n  background: var(--color-accent, #3b82f6);\r\n  color: white;\r\n  border-color: var(--color-accent, #3b82f6);\r\n}\r\n\r\n.dynview-btn-primary:hover:not(:disabled) {\r\n  background: var(--color-accent-hover, #2563eb);\r\n}\r\n\r\n.dynview-btn-primary:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.dynview-btn-secondary {\r\n  background: white;\r\n  color: #555;\r\n  border-color: #d1d5db;\r\n}\r\n\r\n.dynview-btn-secondary:hover {\r\n  background: #f3f4f6;\r\n  color: #333;\r\n}\r\n\r\n.dynview-select {\r\n  padding: 4px 8px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  background: white;\r\n  min-width: 180px;\r\n}\r\n\r\n/* Footer */\r\n.dynview-footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 16px;\r\n  border-top: 1px solid #e0e0e0;\r\n  background: #fafbfc;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dynview-footer-note {\r\n  font-size: 11px;\r\n  color: #888;\r\n}\r\n\r\n/* ===================== Dark mode ===================== */\r\n[data-theme=\"dark\"] .dynview-modal {\r\n  background: var(--color-bg-tertiary);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-header {\r\n  background: var(--color-bg-secondary);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-header h2 {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-close {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-close:hover {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-tabs {\r\n  background: var(--color-bg-secondary);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-tab {\r\n  color: var(--color-text-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-tab:hover {\r\n  background: var(--color-hover);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-tab.active {\r\n  color: var(--color-accent-fg);\r\n  background: var(--color-bg-tertiary);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-tab-view {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-tab-desc {\r\n  background: var(--color-bg-secondary);\r\n  color: var(--color-text-secondary);\r\n  border-left-color: var(--color-accent-fg);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-query-label {\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-query-textarea {\r\n  background: var(--color-input-bg);\r\n  border-color: var(--color-input-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-query-textarea[readonly] {\r\n  background: var(--color-bg-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-status {\r\n  color: var(--color-text-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-status-sep {\r\n  color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-error {\r\n  background: #3a1a1a;\r\n  color: #ef5350;\r\n  border-color: #c62828;\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-grid-container {\r\n  border-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-grid thead {\r\n  background: var(--color-bg-secondary);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-grid th {\r\n  color: var(--color-text);\r\n  background: var(--color-bg-secondary);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-grid td {\r\n  color: var(--color-text);\r\n  border-bottom-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-grid tbody tr:hover {\r\n  background: var(--color-hover);\r\n}\r\n\r\n\r\n[data-theme=\"dark\"] .dynview-rownum {\r\n  background: var(--color-bg-secondary) !important;\r\n  color: var(--color-text-muted) !important;\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-null,\r\n[data-theme=\"dark\"] .dynview-empty,\r\n[data-theme=\"dark\"] .dynview-status-empty {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-select,\r\n[data-theme=\"dark\"] .dynview-select-inline {\r\n  background: var(--color-input-bg);\r\n  border-color: var(--color-input-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-btn-secondary {\r\n  background: var(--color-btn-bg);\r\n  color: var(--color-text);\r\n  border-color: var(--color-btn-border);\r\n}\r\n\r\n/* color 를 빠뜨리면 밝은 모드의 `color: #333` 이 그대로 남아 어두운 배경에 검은 글자가 된다 */\r\n[data-theme=\"dark\"] .dynview-btn-secondary:hover {\r\n  background: var(--color-hover);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-refresh-btn {\r\n  background: var(--color-btn-bg);\r\n  color: var(--color-text-secondary);\r\n  border-color: var(--color-btn-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-refresh-btn:hover:not(:disabled) {\r\n  background: var(--color-hover);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-footer {\r\n  background: var(--color-bg-secondary);\r\n  border-top-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-footer-note {\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n/* ── 동적뷰 즐겨찾기 선택 패널 ─────────────────────────────────────\r\n   최대 5개 탭으로 표시되는 뷰를 이 목록에서 고른다(체크박스, 설명 포함). */\r\n.dynview-picker-toggle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 12px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  color: #374151;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease, border-color 150ms ease;\r\n}\r\n.dynview-picker-toggle:hover { border-color: #3b82f6; }\r\n@media (prefers-reduced-motion: reduce) { .dynview-picker-toggle { transition: none; } }\r\n\r\n.dynview-picker-overlay {\r\n  position: fixed;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background: rgba(0, 0, 0, 0.35);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1200;\r\n}\r\n.dynview-picker-panel {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 32px rgba(0,0,0,0.25);\r\n  width: 90%;\r\n  max-width: 640px;\r\n  /* 목록이 줄면 창이 같이 줄어 검색할 때마다 화면이 출렁였다(사용자 신고).\r\n     높이를 못 박아 **결과 수와 무관하게 같은 크기**를 유지한다 — 남는 자리는 비워 둔다. */\r\n  height: calc(78vh / var(--app-zoom, 1));\r\n  max-height: calc(78vh / var(--app-zoom, 1));\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  animation: dynview-fade-swap 160ms ease-out;\r\n}\r\n@keyframes dynview-fade-swap {\r\n  from { opacity: 0; transform: translateY(-3px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n@media (prefers-reduced-motion: reduce) { .dynview-picker-panel { animation: none; } }\r\n\r\n.dynview-picker-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 14px;\r\n  background: #f8f9fa;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  flex-shrink: 0;\r\n}\r\n.dynview-picker-count { font-weight: 400; color: #6b7280; margin-left: 6px; }\r\n\r\n.dynview-picker-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 6px;\r\n}\r\n.dynview-picker-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 7px 10px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  background: none;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease;\r\n}\r\n.dynview-picker-row:hover { background: #f3f4f6; }\r\n.dynview-picker-row.on { background: #eff6ff; }\r\n.dynview-picker-row.disabled { cursor: not-allowed; opacity: 0.45; }\r\n.dynview-picker-star { flex-shrink: 0; color: #d1d5db; }\r\n.dynview-picker-star.on { color: #f59e0b; fill: #f59e0b; }\r\n.dynview-picker-name { flex-shrink: 0; font-size: 12.5px; font-weight: 600; color: #374151; min-width: 160px; }\r\n.dynview-picker-view {\r\n  flex-shrink: 0;\r\n  font-family: var(--font-mono);\r\n  font-size: 10.5px;\r\n  color: #6b7280;\r\n  background: #f3f4f6;\r\n  border-radius: 4px;\r\n  padding: 1px 6px;\r\n}\r\n.dynview-picker-desc { font-size: 11.5px; color: #9ca3af; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\r\n@media (prefers-reduced-motion: reduce) { .dynview-picker-row { transition: none; } }\r\n\r\n.dynview-picker-footnote {\r\n  padding: 8px 14px;\r\n  border-top: 1px solid #f3f4f6;\r\n  font-size: 11px;\r\n  color: #9ca3af;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.dynview-tab-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  padding: 60px 20px;\r\n  color: #9ca3af;\r\n  font-size: 13px;\r\n}\r\n\r\n[data-theme=\"dark\"] .dynview-picker-toggle { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: var(--color-text); }\r\n[data-theme=\"dark\"] .dynview-picker-panel { background: var(--color-bg-tertiary); color: var(--color-text); }\r\n[data-theme=\"dark\"] .dynview-picker-header { background: var(--color-bg-secondary); border-color: var(--color-border); color: var(--color-text); }\r\n[data-theme=\"dark\"] .dynview-picker-count { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .dynview-picker-row:hover { background: var(--color-hover); }\r\n[data-theme=\"dark\"] .dynview-picker-row.on { background: rgba(59, 130, 246, 0.15); }\r\n[data-theme=\"dark\"] .dynview-picker-name { color: var(--color-text); }\r\n[data-theme=\"dark\"] .dynview-picker-view { background: var(--color-bg-secondary); color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .dynview-picker-desc { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .dynview-picker-star { color: var(--color-border); }\r\n[data-theme=\"dark\"] .dynview-picker-star.on { color: #fbbf24; fill: #fbbf24; }\r\n[data-theme=\"dark\"] .dynview-picker-footnote { color: var(--color-text-muted); border-color: var(--color-border); }\r\n[data-theme=\"dark\"] .dynview-tab-empty { color: var(--color-text-muted); }\r\n\r\n/* 카탈로그 검색창 (picker 헤더 바로 아래) */\r\n.dynview-picker-search {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 12px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  color: #9ca3af;\r\n  flex-shrink: 0;\r\n}\r\n.dynview-picker-search input {\r\n  flex: 1;\r\n  border: none;\r\n  outline: none;\r\n  font-size: 12.5px;\r\n  color: #374151;\r\n  background: transparent;\r\n}\r\n.dynview-picker-refresh {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: none;\r\n  color: #9ca3af;\r\n  cursor: pointer;\r\n}\r\n.dynview-picker-refresh:hover:not(:disabled) { background: #f3f4f6; color: #374151; }\r\n.dynview-picker-refresh:disabled { cursor: not-allowed; opacity: 0.5; }\r\n\r\n.dynview-picker-status {\r\n  padding: 20px 12px;\r\n  text-align: center;\r\n  font-size: 12.5px;\r\n  color: #9ca3af;\r\n}\r\n.dynview-picker-status.error { color: #b91c1c; }\r\n\r\n/* GV$ 와 짝이 있는 V$ 숨기기 토글 — 검색창 바로 아래 */\r\n.dynview-hide-v-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 12px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  font-size: 11.5px;\r\n  color: #6b7280;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* 그리드 아래 상태바의 \"다음 200건\" — 커서 기반 추가 fetch */\r\n.dynview-fetchmore-btn {\r\n  margin-left: 8px;\r\n  padding: 2px 10px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 999px;\r\n  background: #fff;\r\n  color: #1d4ed8;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n.dynview-fetchmore-btn:hover:not(:disabled) { background: #eff6ff; border-color: #3b82f6; }\r\n.dynview-fetchmore-btn:disabled { opacity: 0.6; cursor: not-allowed; }\r\n\r\n[data-theme=\"dark\"] .dynview-picker-search { border-color: var(--color-border); color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .dynview-picker-search input { color: var(--color-text); }\r\n[data-theme=\"dark\"] .dynview-picker-refresh { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .dynview-picker-refresh:hover:not(:disabled) { background: var(--color-hover); color: var(--color-text); }\r\n[data-theme=\"dark\"] .dynview-hide-v-toggle { border-color: var(--color-border); color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .dynview-fetchmore-btn { background: var(--color-btn-bg); border-color: var(--color-btn-border); color: #93c5fd; }\r\n[data-theme=\"dark\"] .dynview-fetchmore-btn:hover:not(:disabled) { background: var(--color-hover); border-color: var(--color-hover-border, #5a5a5a); }\r\n[data-theme=\"dark\"] .dynview-picker-status { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .dynview-picker-status.error { color: #f87171; }\r\n\r\n/* ── 그리드 조작 (2026-09-21) ───────────────────────────────────── */\r\n/* 값 클릭 = 그 값으로 거르기, 머리글 클릭 = 정렬, 더블클릭 = 고정.\r\n   누를 수 있다는 것이 보여야 아무도 찾지 못하는 기능이 되지 않는다. */\r\n.dynview-th-sortable { cursor: pointer; user-select: none; }\r\n.dynview-th-sortable:hover { background: #eef2ff; }\r\n.dynview-th-sorted-asc,\r\n.dynview-th-sorted-desc { color: #1d4ed8; }\r\n.dynview-sort-mark { font-style: normal; font-size: 9px; margin-left: 4px; }\r\n\r\n.dynview-td-filterable { cursor: pointer; }\r\n.dynview-td-filterable:hover { background: #eff6ff; outline: 1px solid #bfdbfe; outline-offset: -1px; }\r\n\r\n/* 행번호 열은 늘 왼쪽 끝에(가로 스크롤에도). 고정한 열은 그 뒤에 제자리에서 선다(utils/gridPin).\r\n   고정 칸은 배경이 있어야 한다 — 없으면 밑으로 지나가는 칸이 비친다 */\r\n.dynview-grid .dynview-rownum { position: sticky; left: 0; z-index: 2; }\r\n.dynview-grid thead .dynview-rownum { z-index: 4; }\r\n.dynview-grid td.dynview-pin { position: sticky; z-index: 1; background: #fff; }\r\n.dynview-grid th.dynview-pin { position: sticky; z-index: 3; }\r\n.dynview-grid .dynview-pin-last { box-shadow: inset -2px 0 0 rgba(59, 130, 246, 0.5); }\r\n.dynview-grid tbody tr:hover td.dynview-pin { background: #f9fafb; }\r\n[data-theme=\"dark\"] .dynview-grid td.dynview-pin { background: var(--color-bg-tertiary); }\r\n[data-theme=\"dark\"] .dynview-grid tbody tr:hover td.dynview-pin { background: var(--color-hover); }\r\n\r\n/* ── 조건·인스턴스 리본 ─────────────────────────────────────────── */\r\n.dynview-filter-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 6px;\r\n  animation: dynview-fade-swap 160ms ease-out;\r\n}\r\n\r\n.dynview-filter-label { font-size: 11px; color: #6b7280; }\r\n\r\n.dynview-filter-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 2px 4px 2px 8px;\r\n  border-radius: 999px;\r\n  border: 1px solid #bfdbfe;\r\n  background: #eff6ff;\r\n  color: #1e40af;\r\n  font-size: 11px;\r\n  max-width: 280px;\r\n}\r\n.dynview-filter-chip b { font-weight: 600; }\r\n.dynview-filter-chip code {\r\n  font-family: var(--font-mono);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-width: 150px;\r\n}\r\n.dynview-filter-chip button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 15px; height: 15px;\r\n  border: none;\r\n  border-radius: 50%;\r\n  background: rgba(0,0,0,0.06);\r\n  color: #1e40af;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n.dynview-filter-chip button:hover { background: rgba(0,0,0,0.14); }\r\n.dynview-filter-chip button:disabled { opacity: 0.4; cursor: not-allowed; }\r\n\r\n.dynview-inst-chip {\r\n  padding: 2px 9px;\r\n  border-radius: 999px;\r\n  border: 1px solid #d1d5db;\r\n  background: #fff;\r\n  color: #374151;\r\n  font-size: 11px;\r\n  cursor: pointer;\r\n  transition: background 150ms ease, border-color 150ms ease;\r\n}\r\n.dynview-inst-chip:hover { border-color: #3b82f6; }\r\n.dynview-inst-chip.active { background: #3b82f6; border-color: #3b82f6; color: #fff; }\r\n.dynview-inst-chip:disabled { opacity: 0.4; cursor: not-allowed; }\r\n\r\n.dynview-filter-note { font-size: 11px; color: #b45309; }\r\n\r\n[data-theme=\"dark\"] .dynview-th-sortable:hover { background: var(--color-hover); }\r\n[data-theme=\"dark\"] .dynview-td-filterable:hover { background: var(--color-hover); outline-color: var(--color-btn-border); }\r\n\r\n[data-theme=\"dark\"] .dynview-filter-chip { background: #1e3a8a; border-color: #1d4ed8; color: #dbeafe; }\r\n[data-theme=\"dark\"] .dynview-filter-chip button { background: rgba(255,255,255,0.12); color: #dbeafe; }\r\n[data-theme=\"dark\"] .dynview-inst-chip { background: var(--color-input-bg); border-color: var(--color-border); color: var(--color-text); }\r\n[data-theme=\"dark\"] .dynview-inst-chip.active { background: #2563eb; border-color: #2563eb; color: #fff; }\r\n[data-theme=\"dark\"] .dynview-filter-note { color: #fcd34d; }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .dynview-filter-bar { animation: none; }\r\n  .dynview-inst-chip { transition: none; }\r\n}\r\n\r\n/* 결과 검색 — 세션 분석과 같은 꼴(2026-10-03) */\r\n.dynview-search { display: flex; align-items: center; gap: 6px; padding: 3px 8px; border: 1px solid #d1d5db; border-radius: 4px; background: #fff; color: #9ca3af; min-width: 200px; }\r\n.dynview-search input { flex: 1; border: none; outline: none; font-size: 12px; background: transparent; color: #374151; min-width: 0; }\r\n.dynview-search-clear { display: inline-flex; border: none; background: none; padding: 1px; border-radius: 3px; color: #9ca3af; cursor: pointer; transition: background-color 150ms ease, color 150ms ease; }\r\n.dynview-search-clear:hover { background: #e5e7eb; color: #374151; }\r\n.dynview-td-searching { box-shadow: inset 0 -2px 0 #3b82f6; }\r\n[data-theme=\"dark\"] .dynview-search { background: var(--color-input-bg); border-color: var(--color-input-border); color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .dynview-search input { color: var(--color-text); }\r\n[data-theme=\"dark\"] .dynview-search-clear:hover { background: var(--color-hover); color: var(--color-text); }\r\n@media (prefers-reduced-motion: reduce) { .dynview-search-clear { transition: none; } }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
